import { render, staticRenderFns } from "./CatalogFiltersParameterValueLink.vue?vue&type=template&id=5b64a39c&"
import script from "./CatalogFiltersParameterValueLink.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersParameterValueLink.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports